import React from 'react'
import { MdCamera } from "react-icons/md";
import './photoLink.scss'
import { sec2 } from '../../data/MainData';
import arrowIcon from "../../assest/arrowIcon2.webp";
import { Link } from 'react-router-dom';

export default function PhotoLink() {

  function clickHandle (){
      <Link to="/photography" />

  }
  return (
    <div className="cameralink">
      <li className="camera-wrap card">
        <a href="/photography"><MdCamera className="camera"/></a>
        
      </li>

      <div>
        <h2>{sec2.subTitle4}</h2>
        <p>{sec2.word1}</p>
        <img src={arrowIcon} alt="" />
      </div>
    </div>
  )
}
